import React, { useState } from 'react'
import Button1 from '../../../../components/form/Button1'
import removeAirlineCommission from '../../../../controllers/settings/AirlineCommission/removeAirlineCommission'
import { enqueueSnackbar } from 'notistack'

export default function AirlineCommissionDelete({close,id,callback}) {
    const [loadings,setLoadings] = useState({submit: false})
    
    async function handleSubmit() {
        setLoadings({...loadings,submit: true})
        const res = await removeAirlineCommission(id)
        setLoadings({...loadings,submit: false})
        if(res?.return) {
            enqueueSnackbar(res?.msg,{variant: 'success'})
            callback && callback()
            close && close();
        } else enqueueSnackbar(res?.msg,{variant: 'error'})
    }
    
  return (
    <div className='flex flex-col gap-2 p-5'>
        <h5>Delete Airline Commission</h5>
        <p>Are you sure you want to remove this airline commission?</p>
        <div className='flex gap-4 items-center'>
            {close ? 
                <div>
                    <Button1 variant='outlined' type='button' onClick={() => close(false)}>Cancel</Button1>
                </div>
            :null}
            <Button1 onClick={() => handleSubmit()} className={'!bg-red-500 !text-white'} loading={loadings?.submit}>Delete</Button1>
        </div>
    </div>
  )
}
